package com.eladfinish.bible.contest.di.config

data class AppInfo(
    val information: String,
)
